
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/analytics'

firebase.initializeApp({
  apiKey: 'AIzaSyCWGN_WDGkdtIE4etiPHxjgrw2XHauXsos',
  authDomain: 'smooth-talkr.firebaseapp.com',
  databaseURL: 'https://smooth-talkr.firebaseio.com',
  projectId: 'smooth-talkr',
  storageBucket: 'smooth-talkr.appspot.com',
  messagingSenderId: '874871578814',
  appId: '1:874871578814:web:ac9cb9cf48dd53a996feef',
  measurementId: 'G-Y0NLKWXEBQ'
})
firebase.analytics()

const db = firebase.firestore()

export default db



// WEBPACK FOOTER //
// ./src/db/index.js